var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-form-item",
        { attrs: { label: "最大值" } },
        [
          _c("el-input-number", {
            attrs: { placeholder: "最大输入值" },
            model: {
              value: _vm.activeData.max,
              callback: function ($$v) {
                _vm.$set(_vm.activeData, "max", $$v)
              },
              expression: "activeData.max",
            },
          }),
        ],
        1
      ),
      _c(
        "el-form-item",
        { attrs: { label: "最小值" } },
        [
          _c("el-input-number", {
            attrs: { placeholder: "最小输入值" },
            model: {
              value: _vm.activeData.min,
              callback: function ($$v) {
                _vm.$set(_vm.activeData, "min", $$v)
              },
              expression: "activeData.min",
            },
          }),
        ],
        1
      ),
      _c(
        "el-form-item",
        { attrs: { label: "步长" } },
        [
          _c("el-input-number", {
            attrs: { min: 1, placeholder: "输入每次增加的数值" },
            model: {
              value: _vm.activeData.step,
              callback: function ($$v) {
                _vm.$set(_vm.activeData, "step", $$v)
              },
              expression: "activeData.step",
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }